<template>
	<div class="loading-container" >
		<img :src="this.$PATH.GET_IMAGE_PATH('loading.gif')" alt="">
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false
		}
	},
	methods: {
		open() {
			this.show = true;
			document.getElementsByTagName("body")[0].style.overflow = "hidden";
			this.$emit("onOpened");
		},
	}
}
</script>

<style lang="scss" scoped>
.loading-container {
	width: 100%;
	height: 100vh;
	background-color: rgba(255, 255, 255, 0.705);
	position: fixed;
	top: 0;
	left: 0;
	opacity: 1;
	visibility: visible;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999999;
	img {
		width: 150px;
		height: 150px;
		object-fit: contain;
	}
}

</style>